const link = (cached_url: string) => ({
  id: '',
  url: '',
  linktype: 'story',
  fieldtype: 'multilink',
  cached_url,
})

const secondaryHeaderLink = (title: string, url: string) => ({
  _uid: `header-secondary-${url}`,
  component: 'header_secondary_navigation_link',
  header_tertiary_navigation_links: [],
  header_secondary_navigation_link_url: link(url),
  header_secondary_navigation_link_title: title,
})

const primaryHeaderLink = (title: string, url: string, children: any[] = []) => ({
  _uid: `header-primary-${url}`,
  component: 'header_primary_navigation_link',
  header_secondary_navigation_links: children,
  header_primary_navigation_link_url: link(url),
  header_primary_navigation_link_title: title,
})

const footerLink = (title: string, url: string) => ({
  _uid: `footer-secondary-${url}`,
  component: 'footer_secondary_navigation_link',
  footer_secondary_navigation_link_url: link(url),
  footer_secondary_navigation_link_title: title,
})

const footerGroup = (title: string, children: any[]) => ({
  _uid: `footer-primary-${title.toLowerCase()}`,
  component: 'footer_primary_navigation_link',
  footer_primary_navigation_link_title: title,
  footer_primary_navigation_link_url: link('#'),
  footer_secondary_navigation_links: children,
})

export default {
  dark_logo: {
    filename: 'https://a.storyblok.com/f/121993/300x102/47817a7e1d/epc-colour.svg',
    alt: 'EPC Improvements',
  },
  light_logo: {
    filename: 'https://a.storyblok.com/f/121993/300x102/6625fa4e05/epc-colour.svg',
    alt: 'EPC Improvements',
  },
  telephone_number: '01245 408 792',
  pre_header_primary_navigation_links: [
    {
      _uid: 'pre-about-us',
      pre_header_primary_navigation_link_title: 'About Us',
      pre_header_primary_navigation_link_url: link('about-us'),
    },
    {
      _uid: 'pre-contact-us',
      pre_header_primary_navigation_link_title: 'Get in Touch',
      pre_header_primary_navigation_link_url: link('contact-us'),
    },
    {
      _uid: 'pre-help-advice',
      pre_header_primary_navigation_link_title: 'Help and Advice',
      pre_header_primary_navigation_link_url: link('news/'),
    },
  ],
  header_primary_navigation_links: [
    primaryHeaderLink('Products', 'solutions/', [
      secondaryHeaderLink('Heat Pumps', 'solutions/heat-pumps/'),
      secondaryHeaderLink('Solar Panels', 'solutions/solar-panels/'),
      secondaryHeaderLink('Battery Storage', 'solutions/battery-storage/'),
      secondaryHeaderLink('Underfloor Heating', 'solutions/underfloor-heating/'),
      secondaryHeaderLink('MVHR', 'solutions/ventilation/'),
    ]),
    primaryHeaderLink('Residential', 'residential/', [
      secondaryHeaderLink('New Build', 'residential/developer'),
      secondaryHeaderLink('Self Build', 'residential/self-build'),
      secondaryHeaderLink('Retrofit', 'residential/retrofit'),
      secondaryHeaderLink('Renovation', 'residential/renovation'),
    ]),
    primaryHeaderLink('Commercial', 'solutions/solar-panels/commercial-solar'),
    primaryHeaderLink('Servicing', 'aftercare/servicing'),
    primaryHeaderLink('Finance', 'finance'),
  ],
  footer_primary_navigation_links: [
    footerGroup('Solutions', [
      footerLink('Solar Panels', 'solutions/solar-panels/'),
      footerLink('Heat Pumps', 'solutions/heat-pumps/'),
      footerLink('Underfloor heating', 'solutions/underfloor-heating/'),
      footerLink('Servicing & Repairs', 'aftercare/servicing'),
    ]),
    footerGroup('Explore', [
      footerLink('Funding', 'funding/'),
      footerLink('Price Match', 'price-match'),
      footerLink('Blog', 'news/'),
      footerLink('Case Studies', 'case-studies/'),
    ]),
    footerGroup('Company', [
      footerLink('About Us', 'about-us'),
      footerLink('FAQs', 'faqs'),
      footerLink('Contact Us', 'contact-us'),
      footerLink('Get a Quote', 'get-a-quote/'),
      footerLink('Terms and Conditions', 'terms-and-conditions'),
      footerLink('Privacy Policy', 'privacy-policy'),
      footerLink('Cookie Policy', 'cookie-policy'),
    ]),
  ],
}
